module.exports = __webpack_public_path__ + "img/garden_gdjt_1.a20fe488.png";